import { message } from "antd";

const adminService = {
  getCustomerData: async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/getCustomerData`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Laden der Metriken war nicht erfolgreich.");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Fehler beim Abrufen der Metriken", error.message);
      message.error(error.message);
      return null;
    }
  },
  getAdminMetrics: async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/getAdminMetrics`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Laden der Metriken war nicht erfolgreich.");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Fehler beim Abrufen der Metriken", error.message);
      message.error(error.message);
    }
  },
  deleteUser: async (user_id) => {
    console.log(user_id);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/deleteUser`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ user_id: user_id }),
        }
      );
      if (!response.ok) {
        throw new Error("Laden der Metriken war nicht erfolgreich.");
      }
      message.success("Nutzer erfolgreich gelöscht");
    } catch (err) {
      console.error("Fehler beim Abrufen der Metriken", err.message);
      message.error(err.message);
    }
  },
  sendUserMessage: async (userId, userMessage) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/send-user-message`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ userId, message: userMessage }),
        }
      );

      if (!response.ok) {
        throw new Error("Nachricht konnte nicht gesendet werden.");
      }

      message.success("Nachricht erfolgreich gesendet.");
      return await response.json();
    } catch (err) {
      console.error("Fehler beim Senden der Nachricht:", err.message);
      message.error("Fehler beim Senden der Nachricht: " + err.message);
      return null;
    }
  },
};

export default adminService;
